import { Box, Skeleton, Text } from '@chakra-ui/react'
import React from 'react'
import formatter from 'utils/formatter'

interface TotalizerBoxProps {
    descricao: string
    quantidadeTotal: number
    totalRegistradora: number
    totalTaxaRegistro: number
    isLoading?: boolean
}

const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value)
}

const Divider: React.FC<{ margin?: string }> = ({ margin }) => (
    <Box
        height="1px"
        background="#18315A"
        margin={margin ?? '16px 0'}
        width="100%"
        maxW="300px"
    />
)

interface ValueDisplayProps {
    label: string
    value: number
    isLoading: boolean
    formatter?: (val: number) => string
}

const ValueDisplay: React.FC<ValueDisplayProps> = ({
    label,
    value,
    formatter,
    isLoading
}) => (
    <Box
        display="flex"
        gap="16px"
        alignItems="center"
        justifyContent="space-between"
        padding="0 4px"
    >
        <Text fontSize="lg">{label}</Text>
        {isLoading ? (
            <Skeleton height="24px" width="100px" />
        ) : (
            <Text fontSize="lg" fontWeight="bold">
                {formatter ? formatter(value) : value.toString()}
            </Text>
        )}
    </Box>
)

const TotalizerBox: React.FC<TotalizerBoxProps> = ({
    descricao,
    quantidadeTotal,
    totalTaxaRegistro,
    totalRegistradora,
    isLoading = false
}) => {
    return (
        <Box
            border="2px solid #18315A"
            borderRadius="8px"
            padding="16px"
            width="100%"
            maxW="360px"
        >
            {isLoading ? (
                <Skeleton height="28px" width="200px" mx="auto" mb="4" />
            ) : (
                <Text fontWeight="bold" fontSize="lg" mb="4" textAlign="center">
                    {descricao}
                </Text>
            )}

            <Divider />

            <ValueDisplay
                isLoading={isLoading}
                label="Quantidade:"
                value={quantidadeTotal}
                formatter={(val: number) =>
                    formatter.formatWithLeadingZero(val).toString()
                }
            />
            <ValueDisplay
                isLoading={isLoading}
                label="Total Registradora:"
                value={totalRegistradora}
                formatter={formatCurrency}
            />
            <ValueDisplay
                isLoading={isLoading}
                label="Total Taxa Registro:"
                value={totalTaxaRegistro}
                formatter={formatCurrency}
            />
        </Box>
    )
}

export default TotalizerBox
